/*
utilities for saving and loading pre-customized bags via the AWS endpoint
*/

//environments
export const environments = {
  PROD: {
    url: "https://7q6dv7yx04.execute-api.us-east-1.amazonaws.com/dev",
    key: "kfzRoNK75R9pM9Rfcr7p3vyiEearfaR7BLZA8Pf4",
    screenshot_url: "https://6u0t12lj6l.execute-api.us-east-1.amazonaws.com/prod/screenshot",
    custom_sewing_variant_id: 4931250225182,
  },
  STAGING: {
    url: "https://neqva6afs4.execute-api.us-west-2.amazonaws.com/dev",
    key: "nDonJkK2hn6DyEGec1MOC2z1jhEX4Wi45ncJJRkT",
    screenshot_url: "https://4efckk3ja2.execute-api.us-east-1.amazonaws.com/dev/screenshot",
    custom_sewing_variant_id: 31344967188589,
  },
  DEVELOPMENT: {
    url: "https://7q6dv7yx04.execute-api.us-east-1.amazonaws.com/dev",
    key: "kfzRoNK75R9pM9Rfcr7p3vyiEearfaR7BLZA8Pf4",
    screenshot_url: "https://4efckk3ja2.execute-api.us-east-1.amazonaws.com/dev/screenshot",
    custom_sewing_variant_id: 31069085597801,
  },
  SCL_DEV: {
    url: "https://7q6dv7yx04.execute-api.us-east-1.amazonaws.com/dev",
    key: "kfzRoNK75R9pM9Rfcr7p3vyiEearfaR7BLZA8Pf4",
    screenshot_url: "https://4efckk3ja2.execute-api.us-east-1.amazonaws.com/dev/screenshot",
    custom_sewing_variant_id: 31069085597801,
  },
  TOMORROW_DEVELOPMENT: {
    url: "https://efpf7kla9c.execute-api.us-east-2.amazonaws.com/beta",
    key: "kfzRoNK75R9pM9Rfcr7p3vyiEearfaR7BLZA8Pf4",
    screenshot_url: "https://4efckk3ja2.execute-api.us-east-1.amazonaws.com/dev/screenshot",
    custom_sewing_variant_id: 40424965079229,
  },
  DEFAULT: {
    url: "https://efpf7kla9c.execute-api.us-east-2.amazonaws.com/beta",
    key: "kfzRoNK75R9pM9Rfcr7p3vyiEearfaR7BLZA8Pf4",
    screenshot_url: "https://4efckk3ja2.execute-api.us-east-1.amazonaws.com/dev/screenshot",
    custom_sewing_variant_id: 40424965079229,
  },
};

export const getEnvironmentConfig = () => {
  const host = location.hostname;
  if (host.endsWith("stoneycloverlane.com")) return environments["PROD"];
  if (host.startsWith("stoney-clover-staging")) return environments["STAGING"];
  if (host.startsWith("stoney-clover-dev")) return environments["DEVELOPMENT"];
  if (host.startsWith("scl-dev")) return environments["SCL_DEV"];
  if (host.startsWith("stoneycloverlane-development")) return environments["TOMORROW_DEVELOPMENT"];
  if (host.startsWith("127.0.0.1")) return environments["TOMORROW_DEVELOPMENT"];
  return environments["PROD"];
};

export function fileToImageDataURL(file) {
  return new Promise((resolve, reject) => {
    if (!file.type.startsWith("image/")) {
      return reject(new Error("File is not an image."));
    }

    const reader = new FileReader();

    reader.onload = () => {
      resolve(reader.result); // Image Data URL
    };

    reader.onerror = (error) => {
      reject(error);
    };

    reader.readAsDataURL(file);
  });
}

/*
CRUD operations for AWS Endpoint
----------------------------------------------------------
*/
const submitRequest = async (endpoint, method, data = {}) => {
  const { key, url } = getEnvironmentConfig();
  const fullUrl = `${url}/${endpoint}`;
  const options = {
    method,
    headers: {
      "Content-Type": "application/json",
      "x-api-key": key,
    },
    body: JSON.stringify(data),
  };

  const response = await fetch(fullUrl, options);
  return response;
};

export const saveItem = async (data) => {
  console.log("saving item for later");
  const response = await submitRequest("save-for-later", "POST", data);
  return response;
};

export const deleteItem = async () => {
  const response = await submitRequest("save-for-later", "DELETE");
  return response;
};

export const getItemLink = async () => {
  const response = await submitRequest("customizer-link", "POST");
  return response;
};

export const getItem = async (id) => {
  const data = {};
  const response = await submitRequest(`customizer-link?link_id=${id}`, "GET", data);
  return response;
};
